import React from 'react';
import PropTypes from 'prop-types';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageSectionHeading from '../../PageSectionHeading';
import { colors } from '../../../styles';

const styles = css`
  padding: 45px 0;
  background-color: ${colors.neutral};
  position: relative;
  z-index: 2;
  @media (min-width: 992px) {
    padding: 90px 0;
  }
  .TextCard {
    width: calc(100% - 30px);
    max-width: 450px;
    margin: 0 15px 30px 15px;
    padding: 40px;
    text-align: left;
    background-color: ${colors.white};
    border: 1px solid ${colors.neutralLight};
    box-shadow: 0 10px 15px 0 rgba(0,0,0,0.05);
  }
  .TextCard_title {
    font-size: 21px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0;
    line-height: 1;
    &::after {
      content: '';
      display: block;
      position: relative;
      width: 75px;
      height: 2px;
      background-color: ${colors.brand3};
      margin: 30px 0;
    }
    @media (min-width: 992px) {
      font-size: 23px;
    }
  }
  .TextCard_text {
    p {
      font-size: 21px;
      font-weight: 400;
      line-height: 1.3;
      margin: 0 0 30px 0;
    }
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    li {
      font-size: 21px;
      font-weight: 400;
      line-height: 1.3;
      margin: 0 0 30px 0;
      padding: 0 0 0 20px;
      position: relative;
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 8px;
        left: 0;
        width: 8px;
        height: 8px;
        background-color: ${colors.brand2};
      }
    }
    a {
      font-weight: 700;
      color: ${colors.color4};
    }
  }
`;


function TextCards({ content }) {
  return (
    <section className={styles}>
      {
        get(content, '[0].section_heading') &&
        <PageSectionHeading h3={get(content, '[0].section_heading')} underdog />
      }
      <div className="container">
        <div className="row justify-content-center pt-lg-5">
          {
            get(content, '[0].cards' || []).map(item => {
              return (
                <div className="TextCard" key={item.title}>
                  <div className="TextCard_content">
                    {
                      get(item, 'title') &&
                      <h4 className="TextCard_title">{get(item, 'title')}</h4>
                    }
                    {
                      get(item, 'text') &&
                      <div className="TextCard_text" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'text'))} />
                    }
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    </section>
  );
}

TextCards.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default TextCards;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/TextCards.section.js